<template>
  <div class="day d-flex flex-column p-3 overflow-auto" :class="getColumnBackgroundClass()">

    <div class="d-flex align-items-center">

      <template v-if="afterTodayFilterCountAssetsByState($props.data, pendingState) > 0">
          <div class="checkbox d-flex" @click="massiveSelection($props.data)">
            <img v-if="! isDayChecked" src="@/assets/icons/checkbox.svg" height="25" alt="checkbox"/>
            <img v-else src="@/assets/icons/checkbox-checked.svg" height="25" alt="checkbox-checked"/>
          </div>
      </template>

      <h5 class="text-violet ms-2 my-2 text-uppercase">
        {{
          isPrioritarioColumn(getPriorityDate($props.data.works))
            ? 'PRIORITARIO'
            : (isCriticoColumn(getPriorityDate($props.data.works))
                ? 'CRITICO'
                : getPriorityDate($props.data.works) ? getPriorityDate($props.data.works).format("DD/MM/YYYY") : '')
        }}
      </h5>

    </div>

    <div class="d-flex flex-column">
      <template v-if="isPrioritarioColumn(getPriorityDate($props.data.works))">
        <template v-for="(dateGroup, date) in groupAllAssetsByDate()" :key="date">
          <div class="date-group mb-2">
            <div class="d-flex align-items-center mb-1 tree-level-1">
              <div class="checkbox me-2" @click="massiveSelectionByDate(date)">
                <img v-if="! isDateChecked(date)" src="@/assets/icons/checkbox.svg" height="20" alt="checkbox"/>
                <img v-else src="@/assets/icons/checkbox-checked.svg" height="20" alt="checkbox-checked"/>
              </div>
              <h6 class="mb-0 orange">{{ date }} {{ getWeekendLabel(date) }}</h6>
            </div>
            <template v-for="(hourGroup, hour) in groupAssetsByHourForDate(dateGroup)" :key="hour">
              <div class="hour-group mb-2 tree-level-2">
                <div class="d-flex align-items-center mb-1">
                  <div class="checkbox me-2" @click="massiveSelectionByHourForDate(date, hour)">
                    <img v-if="! isHourCheckedForDate(date, hour)" src="@/assets/icons/checkbox.svg" height="20" alt="checkbox"/>
                    <img v-else src="@/assets/icons/checkbox-checked.svg" height="20" alt="checkbox-checked"/>
                  </div>
                  <h6 class="mb-0" style="color: #ff8c00;">{{ hour }}</h6>
                </div>
                <template v-for="(file, index) in hourGroup" :key="index">
                  <div
                    class="d-flex align-items-center tree-level-3"
                    :class="`my-1 ${file.previous_test_failed ? 'text-danger' : ''}`">
                    <div class="checkbox my-1 me-2" @click="selectedCurrent(file, $props.data)">
                      <img v-if="! file.checked" src="@/assets/icons/checkbox.svg" height="20" alt="checkbox"/>
                      <img v-else src="@/assets/icons/checkbox-checked.svg" height="20" alt="checkbox-checked"/>
                    </div>

                    <template v-if="file.slug !== assetsType.MILLING">
                      <img class="me-2"
                           :src="require(`@/assets/icons/model/${getFolderNameIconModelBySlug(file.slug)}/${getFileNameIconModelBySlug(file.slug)}-sel.svg`)" height="20" alt="model"/>
                    </template>

                    <img v-if="file.bridge" class="me-2" src="@/assets/icons/project/bridge/bridge-sel.svg" height="20" alt="checkbox" />

                    <small
                      :data-id="file.id"
                      :title="getFileName(file.media)"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      :data-bs-original-title="getFileName(file.media)"
                      class="file text-decoration-underline text-truncate"
                      @click="modalScene(file)">
                      {{ `${file.parentElement.prescription_test.device?.name ? '' : 'NOTAG_'}`}}
                      {{ getFileName(file.media) }} {{ file.id }}
                    </small>

                    <template v-if="file.test_work_queue_types?.length">
                      <img
                        v-for="type in file.test_work_queue_types"
                        :key="type.slug"
                        :src="require(`@/assets/icons/${getTestWorkQueueTypeIcon(type.slug)}`)"
                        :title="type.name"
                        width="18"
                        :alt="type.slug"
                        class="me-1" />
                    </template>
                    <template v-if="hasRemotePrintingType(file.test_work_queue_types)">
                      <div class="badge bg-light-blue me-1">s</div>
                    </template>
                    <template v-else-if="file.is_digital">
                      <div class="badge bg-warning me-1">D</div>
                    </template>
                    <template v-if="file.is_matte">
                      <div :title="$t('Matte')" class="badge bg-home-violet me-1">Ø</div>
                    </template>
                    <div
                      v-if="file.has_feedback"
                      class="badge bg-info fst-italic cp"
                      @click="
                        infoModal.show = true,
                        infoModal.currentAsset = file.parentElement,
                        infoModal.id = file.id"
                    >
                      i
                    </div>
                  </div>
                </template>
              </div>
            </template>
          </div>
        </template>
      </template>

      <template v-else-if="isCriticoColumn(getPriorityDate($props.data.works))">
        <template v-for="(dateGroup, date) in groupAllAssetsByDate()" :key="date">
          <div class="date-group mb-2">
            <div class="d-flex align-items-center mb-1 tree-level-1">
              <div class="checkbox me-2" @click="massiveSelectionByDate(date)">
                <img v-if="! isDateChecked(date)" src="@/assets/icons/checkbox.svg" height="20" alt="checkbox"/>
                <img v-else src="@/assets/icons/checkbox-checked.svg" height="20" alt="checkbox-checked"/>
              </div>
              <h6 class="mb-0 red">{{ date }}</h6>
            </div>
            
            <template v-if="isToday(date)">
              <template v-for="(hourGroup, hour) in groupAssetsByHourForDate(dateGroup)" :key="hour">
                <div class="hour-group mb-2 tree-level-2">
                  <div class="d-flex align-items-center mb-1">
                    <div class="checkbox me-2" @click="massiveSelectionByHourForDate(date, hour)">
                      <img v-if="! isHourCheckedForDate(date, hour)" src="@/assets/icons/checkbox.svg" height="20" alt="checkbox"/>
                      <img v-else src="@/assets/icons/checkbox-checked.svg" height="20" alt="checkbox-checked"/>
                    </div>
                    <h6 class="mb-0" style="color: #dc3545;">{{ hour }}</h6>
                  </div>
                  <template v-for="(file, index) in hourGroup" :key="index">
                    <div
                      class="d-flex align-items-center tree-level-3"
                      :class="`my-1 ${file.previous_test_failed ? 'text-danger' : ''}`">
                      <div class="checkbox my-1 me-2" @click="selectedCurrent(file, $props.data)">
                        <img v-if="! file.checked" src="@/assets/icons/checkbox.svg" height="20" alt="checkbox"/>
                        <img v-else src="@/assets/icons/checkbox-checked.svg" height="20" alt="checkbox-checked"/>
                      </div>

                      <template v-if="file.slug !== assetsType.MILLING">
                        <img class="me-2"
                             :src="require(`@/assets/icons/model/${getFolderNameIconModelBySlug(file.slug)}/${getFileNameIconModelBySlug(file.slug)}-sel.svg`)" height="20" alt="model"/>
                      </template>

                      <img v-if="file.bridge" class="me-2" src="@/assets/icons/project/bridge/bridge-sel.svg" height="20" alt="checkbox" />

                      <small
                        :data-id="file.id"
                        :title="getFileName(file.media)"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        :data-bs-original-title="getFileName(file.media)"
                        class="file text-decoration-underline text-truncate"
                        @click="modalScene(file)">
                        {{ `${file.parentElement.prescription_test.device?.name ? '' : 'NOTAG_'}`}}
                        {{ getFileName(file.media) }} {{ file.id }}
                      </small>

                      <template v-if="file.test_work_queue_types?.length">
                        <img
                          v-for="type in file.test_work_queue_types"
                          :key="type.slug"
                          :src="require(`@/assets/icons/${getTestWorkQueueTypeIcon(type.slug)}`)"
                          :title="type.name"
                          width="18"
                          :alt="type.slug"
                          class="me-1" />
                      </template>
                      <template v-if="hasRemotePrintingType(file.test_work_queue_types)">
                        <div class="badge bg-light-blue me-1">s</div>
                      </template>
                      <template v-else-if="file.is_digital">
                        <div class="badge bg-warning me-1">D</div>
                      </template>
                      <template v-if="file.is_matte">
                        <div :title="$t('Matte')" class="badge bg-home-violet me-1">Ø</div>
                      </template>
                      <div
                        v-if="file.has_feedback"
                        class="badge bg-info fst-italic cp"
                        @click="
                          infoModal.show = true,
                          infoModal.currentAsset = file.parentElement,
                          infoModal.id = file.id"
                      >
                        i
                      </div>
                    </div>
                  </template>
                </div>
              </template>
            </template>
            
            <template v-else>
              <template v-for="(file, index) in dateGroup" :key="index">
                <div
                  class="d-flex align-items-center tree-level-2"
                  :class="`my-1 ${file.previous_test_failed ? 'text-danger' : ''}`">
                  <div class="checkbox my-1 me-2" @click="selectedCurrent(file, $props.data)">
                    <img v-if="! file.checked" src="@/assets/icons/checkbox.svg" height="20" alt="checkbox"/>
                    <img v-else src="@/assets/icons/checkbox-checked.svg" height="20" alt="checkbox-checked"/>
                  </div>

                  <template v-if="file.slug !== assetsType.MILLING">
                    <img class="me-2"
                         :src="require(`@/assets/icons/model/${getFolderNameIconModelBySlug(file.slug)}/${getFileNameIconModelBySlug(file.slug)}-sel.svg`)" height="20" alt="model"/>
                  </template>

                  <img v-if="file.bridge" class="me-2" src="@/assets/icons/project/bridge/bridge-sel.svg" height="20" alt="checkbox" />

                  <small
                    :data-id="file.id"
                    :title="getFileName(file.media)"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    :data-bs-original-title="getFileName(file.media)"
                    class="file text-decoration-underline text-truncate"
                    @click="modalScene(file)">
                    {{ `${file.parentElement.prescription_test.device?.name ? '' : 'NOTAG_'}`}}
                    {{ getFileName(file.media) }} {{ file.id }}
                  </small>

                  <template v-if="file.test_work_queue_types?.length">
                    <img
                      v-for="type in file.test_work_queue_types"
                      :key="type.slug"
                      :src="require(`@/assets/icons/${getTestWorkQueueTypeIcon(type.slug)}`)"
                      :title="type.name"
                      width="18"
                      :alt="type.slug"
                      class="me-1" />
                  </template>
                  <template v-if="hasRemotePrintingType(file.test_work_queue_types)">
                    <div class="badge bg-light-blue me-1">s</div>
                  </template>
                  <template v-else-if="file.is_digital">
                    <div class="badge bg-warning me-1">D</div>
                  </template>
                  <template v-if="file.is_matte">
                    <div :title="$t('Matte')" class="badge bg-home-violet me-1">Ø</div>
                  </template>
                  <div
                    v-if="file.has_feedback"
                    class="badge bg-info fst-italic cp"
                    @click="
                      infoModal.show = true,
                      infoModal.currentAsset = file.parentElement,
                      infoModal.id = file.id"
                  >
                    i
                  </div>
                </div>
              </template>
            </template>
          </div>
        </template>
      </template>

      <template v-else>
        <template v-for="(hourGroup, hour) in groupAllAssetsByHour()" :key="hour">
          <div class="hour-group mb-2 tree-level-2">
            <div class="d-flex align-items-center mb-1">
              <div class="checkbox me-2" @click="massiveSelectionByHour(hour)">
                <img v-if="! isHourChecked(hour)" src="@/assets/icons/checkbox.svg" height="20" alt="checkbox"/>
                <img v-else src="@/assets/icons/checkbox-checked.svg" height="20" alt="checkbox-checked"/>
              </div>
              <h6 class="mb-0">{{ hour }}</h6>
            </div>
            <template v-for="(file, index) in hourGroup" :key="index">
              <div
                class="d-flex align-items-center tree-level-3"
                :class="`my-1 ${file.previous_test_failed ? 'text-danger' : ''}`">
                <div class="checkbox my-1 me-2" @click="selectedCurrent(file, $props.data)">
                  <img v-if="! file.checked" src="@/assets/icons/checkbox.svg" height="20" alt="checkbox"/>
                  <img v-else src="@/assets/icons/checkbox-checked.svg" height="20" alt="checkbox-checked"/>
                </div>

                <template v-if="file.slug !== assetsType.MILLING">
                  <img class="me-2"
                       :src="require(`@/assets/icons/model/${getFolderNameIconModelBySlug(file.slug)}/${getFileNameIconModelBySlug(file.slug)}-sel.svg`)" height="20" alt="model"/>
                </template>

                <img v-if="file.bridge" class="me-2" src="@/assets/icons/project/bridge/bridge-sel.svg" height="20" alt="checkbox" />

                <small
                  :data-id="file.id"
                  :title="getFileName(file.media)"
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  :data-bs-original-title="getFileName(file.media)"
                  class="file text-decoration-underline text-truncate"
                  @click="modalScene(file)">
                  {{ `${file.parentElement.prescription_test.device?.name ? '' : 'NOTAG_'}`}}
                  {{ getFileName(file.media) }} {{ file.id }}
                </small>

                <template v-if="file.test_work_queue_types?.length">
                  <img
                    v-for="type in file.test_work_queue_types"
                    :key="type.slug"
                    :src="require(`@/assets/icons/${getTestWorkQueueTypeIcon(type.slug)}`)"
                    :title="type.name"
                    width="18"
                    :alt="type.slug"
                    class="me-1" />
                </template>
                <template v-if="hasRemotePrintingType(file.test_work_queue_types)">
                  <div class="badge bg-light-blue me-1">s</div>
                </template>
                <template v-else-if="file.is_digital">
                  <div class="badge bg-warning me-1">D</div>
                </template>
                <template v-if="file.is_matte">
                  <div :title="$t('Matte')" class="badge bg-home-violet me-1">Ø</div>
                </template>
                <div
                  v-if="file.has_feedback"
                  class="badge bg-info fst-italic cp"
                  @click="
                    infoModal.show = true,
                    infoModal.currentAsset = file.parentElement,
                    infoModal.id = file.id"
                >
                  i
                </div>
              </div>
            </template>
          </div>
        </template>
      </template>
    </div>

  </div>

  <Modal
    v-if="showModal"
    :data="scene"
    @hidden="closeModal" />

  <Standard
    v-if="infoModal.show"
    size="lg"
    :modal_id="infoModal.id"
    :decline_label="$t('close')"
    @hidden="
      infoModal.show = value,
      infoModal.id = null,
      infoModal.currentAsset = null"
    >
    <RenderFeedbackAndNotes :data="infoModal.currentAsset" />
  </Standard>
</template>

<script>
import { reactive, ref, toRaw, watch, onMounted, computed, inject } from "vue";
import { Tooltip } from "bootstrap";
import moment from "moment";
import _find from "lodash/find";

import { useTypeChecker } from '@/composables/useTypeChecker';
import { useWorkingDays } from '@/composables/useWorkingDays';
import { useStateIcon } from '@/composables/useStateIcon';
import {fetchTemporaryUrl} from "@/use/repositories/assets/fetchTemporaryUrl";
import {getFolderNameIconModelBySlug} from "@/use/utilities/getFolderNameIconModelBySlug";
import {getFileNameIconModelBySlug} from "@/use/utilities/getFileNameIconModelBySlug";

import Modal from '@/components/Scene/Modal';
import Standard from "@/components/Modal/Standard";
import RenderFeedbackAndNotes from "@/components/cam/common/RenderFeedbackAndNotes";

export default {
  name: "RenderDay",
  components: {
    Modal,
    Standard,
    RenderFeedbackAndNotes
  },
  props: [
    'data',
    'afterToday'
  ],
  emits: [
    'filesReadyToDownload',
  ],
  setup(props, {emit}) {
    const filesReadyForDownload = ref([]);
    const showModal = ref(false);
    const infoModal = reactive({
      show: false,
      id: null,
      currentAsset: null,
    })
    const scene = reactive({
      id: null,
      modal_id: null,
      title: null,
      subtitle: null,
      decline_label: null,
      temporary_url: null,
      child_internal_phase_id: null,
      test_work_queue_phase_id: null,
      child_id: null,
    });
    const { hasRemotePrintingType } = useTypeChecker();
    const { isCritico, isPrioritario, getWeekendLabel } = useWorkingDays();
    const { getTestWorkQueueTypeIcon } = useStateIcon();
    const { assetsType, states } = inject("constants");

    onMounted(() => {
      createTooltips();
    });

    const isDayChecked = computed(() => {
      let checked = true;
      Object.keys(props.data.works).forEach((key) => {
        if (props.data.works[key].length > 0) {
          props.data.works[key].forEach((el) => {
            if (el.assets.length > 0) {
              el.assets.forEach((file) => {
                if (!file.checked && file.state === states.PENDING) {
                  checked = false;
                }
              });
            }
          });
        }
      });

      return checked;
    });

    watch(() => props.data, () => {
      createTooltips();
    });

    const createTooltips = () => {
      let tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
      tooltipTriggerList.map(function (tooltipTriggerEl) {
        return new Tooltip(tooltipTriggerEl);
      });
    };

    const getFileName = (media) => {
      return _find(media).file_name;
    };

    const isPrioritarioColumn = (date) => {
      if (!date) return false;
      return isPrioritario(moment(date));
    };

    const isCriticoColumn = (date) => {
      if (!date) return false;
      return isCritico(moment(date));
    };

    const isToday = (dateString) => {
      const date = moment(dateString, "DD/MM/YYYY");
      return date.isSame(moment(), 'day');
    };

    const groupAllAssetsByHour = () => {
      const allPendingAssets = [];

      Object.values(props.data.works).forEach((works) => {
        works.forEach((el) => {
          const pendingAssets = filterAssetsByState(el.assets, states.PENDING);
          pendingAssets.forEach((file) => {
            file.parentElement = el;
            allPendingAssets.push(file);
          });
        });
      });

      const groupedByHour = {};

      allPendingAssets.forEach((file) => {
        const hour = moment(file.delivery_date).format("HH:mm");

        if (!groupedByHour[hour]) {
          groupedByHour[hour] = [];
        }
        groupedByHour[hour].push(file);
      });

      return Object.keys(groupedByHour)
        .sort()
        .reduce((sorted, hour) => {
          sorted[hour] = groupedByHour[hour];
          return sorted;
        }, {});
    };

    const isHourChecked = (hour) => {
      const hourGroups = groupAllAssetsByHour();
      const hourGroup = hourGroups[hour];

      if (!hourGroup || hourGroup.length === 0) return false;

      return hourGroup.every((file) => file.checked);
    };

    const massiveSelectionByHour = (hour) => {
      const hourGroups = groupAllAssetsByHour();
      const hourGroup = hourGroups[hour];

      if (!hourGroup || hourGroup.length === 0) return;

      const setCheck = !isHourChecked(hour);
      filesReadyForDownload.value = [];

      hourGroup.forEach((file) => {
        if (file.state === states.PENDING) {
          file.checked = setCheck;
          filesReadyForDownload.value.push(file);
        }
      });

      emit("filesReadyToDownload", toRaw(filesReadyForDownload.value));
    };

    const getAllPendingAssets = () => {
      const allPendingAssets = [];

      Object.values(props.data.works).forEach((works) => {
        works.forEach((el) => {
          const pendingAssets = filterAssetsByState(el.assets, states.PENDING);
          pendingAssets.forEach((file) => {
            file.parentElement = el;
            allPendingAssets.push(file);
          });
        });
      });

      return allPendingAssets;
    };

    const groupAllAssetsByDate = () => {
      const allPendingAssets = [];

      Object.values(props.data.works).forEach((works) => {
        works.forEach((el) => {
          const pendingAssets = filterAssetsByState(el.assets, states.PENDING);
          pendingAssets.forEach((file) => {
            file.parentElement = el;
            allPendingAssets.push(file);
          });
        });
      });

      const groupedByDate = {};

      allPendingAssets.forEach((file) => {
        const date = moment(file.delivery_date).format("DD/MM/YYYY");

        if (!groupedByDate[date]) {
          groupedByDate[date] = [];
        }
        groupedByDate[date].push(file);
      });

      return Object.keys(groupedByDate)
        .sort((a, b) => {
          const dateA = moment(a, "DD/MM/YYYY");
          const dateB = moment(b, "DD/MM/YYYY");
          return dateA.diff(dateB);
        })
        .reduce((sorted, date) => {
          sorted[date] = groupedByDate[date];
          return sorted;
        }, {});
    };

    const isDateChecked = (date) => {
      const dateGroups = groupAllAssetsByDate();
      const dateGroup = dateGroups[date];

      if (!dateGroup || dateGroup.length === 0) return false;

      return dateGroup.every((file) => file.checked);
    };

    const massiveSelectionByDate = (date) => {
      const dateGroups = groupAllAssetsByDate();
      const dateGroup = dateGroups[date];

      if (!dateGroup || dateGroup.length === 0) return;

      const setCheck = !isDateChecked(date);
      filesReadyForDownload.value = [];

      dateGroup.forEach((file) => {
        if (file.state === states.PENDING) {
          file.checked = setCheck;
          filesReadyForDownload.value.push(file);
        }
      });

      emit("filesReadyToDownload", toRaw(filesReadyForDownload.value));
    };

    const groupAssetsByHourForDate = (dateGroup) => {
      const groupedByHour = {};

      dateGroup.forEach((file) => {
        const hour = moment(file.delivery_date).format("HH:mm");
        if (!groupedByHour[hour]) {
          groupedByHour[hour] = [];
        }
        groupedByHour[hour].push(file);
      });

      return Object.keys(groupedByHour)
        .sort()
        .reduce((sorted, hour) => {
          sorted[hour] = groupedByHour[hour];
          return sorted;
        }, {});
    };

    const isHourCheckedForDate = (date, hour) => {
      const dateGroups = groupAllAssetsByDate();
      const dateGroup = dateGroups[date];
      if (!dateGroup) return false;

      const hourGroups = groupAssetsByHourForDate(dateGroup);
      const hourGroup = hourGroups[hour];
      if (!hourGroup || hourGroup.length === 0) return false;

      return hourGroup.every((file) => file.checked);
    };

    const massiveSelectionByHourForDate = (date, hour) => {
      const dateGroups = groupAllAssetsByDate();
      const dateGroup = dateGroups[date];
      if (!dateGroup) return;

      const hourGroups = groupAssetsByHourForDate(dateGroup);
      const hourGroup = hourGroups[hour];
      if (!hourGroup || hourGroup.length === 0) return;

      const setCheck = !isHourCheckedForDate(date, hour);
      filesReadyForDownload.value = [];

      hourGroup.forEach((file) => {
        if (file.state === states.PENDING) {
          file.checked = setCheck;
          filesReadyForDownload.value.push(file);
        }
      });

      emit("filesReadyToDownload", toRaw(filesReadyForDownload.value));
    };


    const massiveSelection = async () => {
      let setCheck = !isDayChecked.value;
      filesReadyForDownload.value = [];

      Object.keys(props.data.works).forEach((key) => {
        if (props.data.works[key].length > 0) {
          props.data.works[key].forEach((el) => {
            if (el.assets.length > 0) {
              el.assets.forEach((file) => {
                if (file.state === states.PENDING) {
                  if (file.checked === setCheck) return;
                  file.checked = setCheck;
                  filesReadyForDownload.value.push(file);
                }
              });
            }
          });
        }
      });

      emit("filesReadyToDownload", toRaw(filesReadyForDownload.value));
    }

    const selectedCurrent = async (asset, day) => {
      filesReadyForDownload.value = [];
      let isAllChecked = true;

      filesReadyForDownload.value.push(asset);
      asset.checked = !asset.checked;

      Object.values(day.works).forEach((works) => {
        works.forEach((data) => {
          data.assets.forEach((asset) => {
            if (asset.checked === false) {
              return isAllChecked = false;
            }
          });
        });
      });

      day.checked = isAllChecked;

      emit('filesReadyToDownload', toRaw(filesReadyForDownload.value));
    }

    const modalScene = async (asset) => {
      scene.id = asset.id;
      scene.modal_id = asset.id;
      scene.decline_label = "chiudi";
      scene.child_internal_phase_id = asset.child_internal_phase_id;
      scene.test_work_queue_phase_id = asset.test_work_queue_phase_id;
      scene.child_id = asset.child_id;

      await fetchTemporaryUrl(asset.id).then(async (response) => {
        scene.temporary_url = response.temporary_url;
        showModal.value = true;
      });
    }

    const closeModal = async (value) => {
      showModal.value = value;
    }

    const filterAssetsByState = (assets, state) => {
      return assets.filter((asset) => {
        return asset.state === state;
      });
    };

    const afterTodayFilterCountAssetsByState = (data, state) => {
      let count = 0;

      Object.values(data.works).forEach((works) => {
        works.forEach((data) => {
          data.assets.forEach((asset) => {
            if (asset.state.toLowerCase() === state) {
              count++;
            }
          });
        });
      });

      return count;
    };

    const getPriorityDate = (works) => {
      if (!works) return null;
      const firstGroup = _find(works);
      if (!firstGroup || firstGroup.length === 0) return null;
      const firstItem = firstGroup[0];
      return firstItem ? firstItem.delivery_date : null;
    }

    const getColumnBackgroundClass = () => {
      if (!props.data || !props.data.works) {
        return 'bg-white';
      }
      
      const priorityDate = getPriorityDate(props.data.works);

      if (isCriticoColumn(priorityDate)) {
        return 'bg-light-pastel-red';
      }
      if (isPrioritarioColumn(priorityDate)) {
        return 'bg-pastel-yellow';
      }
      return 'bg-white';
    }

    const pendingState = computed(() => states.PENDING);

    return {
      moment,
      hasRemotePrintingType,
      getTestWorkQueueTypeIcon,
      isPrioritarioColumn,
      isCriticoColumn,
      isToday,
      massiveSelection,
      selectedCurrent,
      showModal,
      closeModal,
      modalScene,
      scene,
      getFileName,
      filterAssetsByState,
      afterTodayFilterCountAssetsByState,
      isDayChecked,
      getPriorityDate,
      getFolderNameIconModelBySlug,
      getFileNameIconModelBySlug,
      assetsType,
      infoModal,
      groupAllAssetsByHour,
      isHourChecked,
      massiveSelectionByHour,
      getAllPendingAssets,
      groupAllAssetsByDate,
      isDateChecked,
      massiveSelectionByDate,
      groupAssetsByHourForDate,
      isHourCheckedForDate,
      massiveSelectionByHourForDate,
      getWeekendLabel,
      getColumnBackgroundClass,
      pendingState,
    }
  }
}
</script>

<style scoped>

  .day {
    border-right: 3px solid #725D82;
    width: 30rem;
    flex-shrink: 0;
  }
  .checkbox:hover,
  .file:hover {
    cursor: pointer;
  }
  .hour-group {
    border-left: 2px solid #e9ecef;
    padding-left: 8px;
  }
  .date-group {
    border-left: 2px solid #e9ecef;
    padding-left: 8px;
  }
  :global(.orange) {
    color: orange !important;
  }
  
  .tree-level-1 {
    margin-left: 0;
  }
  
  .tree-level-2 {
    margin-left: 20px;
  }
  
  .tree-level-3 {
    margin-left: 25px;
  }
  
  .tree-level-1-future {
    margin-left: 10px;
  }

</style>
